import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import importedDatabase from '../data/database.json'
import Header from './Header'
import Calendar from './Calendar'
import 'react-day-picker/lib/style.css';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
`

function App() {
  const [db, setDb] = useState(null)
  const [today, setToday] = useState(() => new Date().toLocaleDateString())
  const [todayEvents, setTodayEvents] = useState(null)
  const [showForm, setShowForm] = useState(false) // We have showForm up in the tree to register click events outside of the form so we can close it.

  // We initially import the data from our database.json file. We pass an empty array as the second argument to useEffect to signal that we want this function to fire only one time.
  useEffect(() => {
    setDb(importedDatabase)
  }, [])

  // This function will run everytime db or today change. We populate the events array with the events of today. If there are no events, we pass an empty array.
  useEffect(() => {
    if (db && db.find(el => el.day === today)) {
      setTodayEvents(db.find(el => el.day === today).events)
    } else if (db) {
      setTodayEvents([])
    }
  }, [db, today])
  
  // The first time App.js mounts, we don't have a db value. Show a loading screen.
  if (!db) {
    return <div>Loading...</div>
  }

  return (
    <AppContainer onClick={() => setShowForm(false)}>
      <Header today={today} setToday={setToday} db={db} setDb={setDb} showForm={showForm} setShowForm={setShowForm}/>
      <Calendar todayEvents={todayEvents}/>
    </AppContainer>
  );
}

export default App;

/*
INSTRUNCTIONS - How to add a new event to the database (src/data/database.json)
Since it's not possible to add comments to a .json file, I'll specify here how to add a new event.
(Be aware that it's also possible to add a new event directly from the web app.)

- Create a day-object. The day-object must have 2 properties: "day" and "events". 
  "events" must be an array of event-objects. 
  "day" must be a string and has to follow this pattern -> "m/dd/yyyy".
  event-objects go inside the "events" array of the day-object.

- "start" and "end" hours must be strings, and the string must have 4 characters. 
  See the "timeConvert" object inside src/helpers/functions.js for a comprehensive table of the conversions.

  Examples of "start"||"end" property:
  6am must be specified as 0600
  6pm must be specified as 1800
  12am must be specified as 0000
  12:30am must be specified as 0030
  12pm must be specified as 1200
  12:30pm must be specified as 1230


  You can create an event-object and put in inside the "events" array of an already existing object.
  You can also create a brand new day-object. 

  Follows an example of a day-object. In this example, the "events" array has only one event-object.

  {
    "day": "3/23/2020",
    "events": [
      {
        "start": "0200",
        "end": "0330",
        "allday": false,
        "name": "Join Robin",
        "location": "MacLaren's Pub",
        "uniqueID": 8
      }
    }
  }

  The day-objects are inside the database.json file.
  The .json file is located ad src/data/database.json
*/